import axios from 'axios';
import scrollIt from "../modules/scroll-it";

const pageNav = function (opt) {
    const rootBlock = opt.rootEl;
    const navContainer = opt.rootEl.querySelector('.js-nav-container');
    const navButton = opt.rootEl.querySelector('.js-nav-more');
    const endpoint = opt.endpoint;
    let isModal = opt.isModal;
    let perPage = window.siteInfo.isMobile ? opt.mobilePerPage : opt.perPage;
    let isLessThanOnePage = false;

    const deleteAndHideEls = function() {
        // скрываем третий элемент на мобилке и убираем последний
        const allItems = rootBlock.querySelectorAll('.js-nav-item');
        allItems.forEach((item, idx) => {
            if(idx > 1) {
                item.style.display = 'none';
            }
        });
    }

    const initPageNav = function() {
        const allDataPageItems = rootBlock.querySelectorAll('[data-page]');
        allDataPageItems.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                getNavPage(item.dataset.page);
            });
        });
    }

    const initNavShow = () => {
        navButton.addEventListener('click', (e) => {
            e.preventDefault();
            rootBlock.querySelectorAll('.js-nav-item').forEach((item) => {
                item.style.display = 'block';
            });
            console.log(rootBlock)
            // rootBlock.querySelector('.r-page-nav').style.display = 'block';
            navButton.style.display = 'none';
        });
    }

    const getNavPage = (num) => {
        axios.get(
            endpoint,
            {
                params: {
                    'PAGEN_1': num,
                    'per_page': perPage,
                }
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        ).then(({ data }) => {
            navContainer.innerHtml = data;
            showLastInMobile();
            rootBlock.querySelector('.r-page-nav').style.display = 'none';

            scrollIt(rootBlock, 500);

            if (isModal) {
                initModal();
            }

            initPageNav();
        }).catch((error) => {
            console.error("/ajax/news.php error: " + error);
        });
    }

    const initModal = () => {
        navContainer.querySelectorAll('[data-modal]').forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const type = item.dataset.modal;

                if (!type) return false;
                rModal.show(item, type);
            });
        });
    }

    const showLastInMobile = () => {
        if (window.siteInfo.isMobile) { // global in main.js
            navContainer.querySelectorAll('.js-nav-item').forEach((item) => {
                item.style.display = 'block';
            });
        }
    }

    const elements = rootBlock.querySelectorAll('.js-nav-item');

    isLessThanOnePage = window.siteInfo.isMobile ? elements.length < 3 : elements.length < 4;

    if (window.siteInfo.isMobile && !isLessThanOnePage) {
        deleteAndHideEls();
    }

    if (!isLessThanOnePage) {
        initNavShow();
        initPageNav();
    } else {
        navButton.style.display = 'none';
        rootBlock.querySelectorAll('.js-nav-item').forEach((item) => {
            item.style.display = 'block';
        });
    }
};

export default pageNav;